import { useCallback, useMemo } from "react"
import { useParams } from "react-router-dom"
import { useApplicationProperties } from "../../../../../hooks/useApplicationProperties"
import { useDeleteConfirm } from "../../../../../hooks/useDeleteConfirm"
import { ApplicationPropertyGet } from "../../../../models/ApplicationProperty"
import { DimaFeatureShortNameEnum } from "../../../../models/Authorization"
import { deleteEntity } from "../../../../utils/deleteEntity"
import { booleanComparator, getDoneIcon, getEmptyIcon } from "../../../../utils/getBooleanFlagIcon"
import { DiMaAddButton } from "../../../partials/DiMaAddButton"
import { EntityRow, EntityTab } from "../../../partials/EntityTab"

export function ApplicationProperties() {
  const { applicationId } = useParams()
  const { requestDelete, DeleteConfirmDialog } = useDeleteConfirm()

  const { applicationProperties, isLoadingApplicationProperties } =
    useApplicationProperties(applicationId)

  const cols = [
    {
      field: "name",
      headerName: "Name",
      isLink: true,
      linkBasePath: `/applications/${applicationId}/properties`,
    },
    { field: "type", headerName: "Type" },
    {
      field: "isRequestable",
      headerName: "Is Requestable",
      renderCell: (row: EntityRow) => row.isRequestable ? getDoneIcon() : getEmptyIcon(),
      sortComparator: booleanComparator,
    },
  ]

  const sorted = [...applicationProperties].sort(
    (a: ApplicationPropertyGet, b: ApplicationPropertyGet) =>
      (a.name ?? "").localeCompare(b.name ?? "")
  )

  const rows = sorted.map((p: ApplicationPropertyGet) => ({
    id: p.name,
    name: p.name,
    type: p.type,
    isRequestable: p.isRequestable,
  }))

  const toolbar = useMemo(
    () => (
      <DiMaAddButton
        url={`/applications/${applicationId}/properties/create`}
        feature={DimaFeatureShortNameEnum.AM}
      />
    ),
    [applicationId]
  )

  const handleActionMenuClick = useCallback((item: { title: string }, row: EntityRow) => {
      if (item.title === "Delete") {
        requestDelete(() =>
          deleteEntity(
            `/applications/${applicationId}/properties/${row.id}`
          )
        )
      }
    }, [applicationId, requestDelete])

  return (
    <>
      {DeleteConfirmDialog}
      <EntityTab
        rows={rows}
        cols={cols}
        isLoading={isLoadingApplicationProperties}
        toolbar={toolbar}
        actionItems={[{ title: "Delete", iconName: "icon_abb_dias icon-abb_delete" }]}
        onActionMenuClick={handleActionMenuClick}
      />
    </>
  )
}
